import { JVCEF, VRPAT } from '~/config/constants';

export default function getCompanyFirstNameByIssuer(issuer: string): string {
  switch (issuer) {
    case VRPAT:
      return 'VR';
    case JVCEF:
      return 'CAIXA';
    default:
      return '';
  }
}
